import { render } from "./ClickableColorPill.vue?vue&type=template&id=39e561a6"
import script from "./ClickableColorPill.vue?vue&type=script&lang=js"
export * from "./ClickableColorPill.vue?vue&type=script&lang=js"

import "./ClickableColorPill.vue?vue&type=style&index=0&id=39e561a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__